// removed by extract-text-webpack-plugin
module.exports = {"Cell":"_1oijSDnqonJd4YLIGxO6m8","hovered":"_2r4EVxPvkSRd7wlDwIVemg"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/Cell/style.css
// module id = 293
// module chunks = 0